import { Button, Callout, FormGroup, InputGroup, Intent, Checkbox, Icon, Popover, PopoverPosition, Collapse, Slider, RadioGroup, Radio } from '@blueprintjs/core'
import cx from 'classnames'
import { BotConfig, BotTemplate, MessagingConfig, chatTheme } from 'enablex/sdk'
import { lang, toast } from 'enablex/shared'
import _ from 'lodash'
import ms from 'ms'
import React, { Component, Fragment } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { generatePath, RouteComponentProps } from 'react-router'
import Select from 'react-select'
import api from '~/app/api'

import LoadingSection from '~/app/common/LoadingSection'
import PageContainer from '~/app/common/PageContainer'
import { AppState } from '~/app/rootReducer'
import { getActiveWorkspace } from '~/auth/basicAuth'
import PhoneCall from '~/icons/PhoneCall'
import VideoCall from '~/icons/VideoCall'
import WebChatIcon from '~/icons/WebChatIcon'
import WhatsAppIcon from '~/icons/WhatsAppIcon'
import RcsIcon from '~/icons/RcsIcon'
import FacebookIcon from '~/icons/FacebookIcon'
import InstagramIcon from '~/icons/InstagramIcon'
import DropzoneComponent from '~/workspace/bots/DropZoneComponent'
import PreviewDialog from './PreviewDialog'
import { fetchBotCategories, fetchBots, fetchBotTemplates } from './reducer'
import style from './style.scss'
import { MessengerConfigDialog } from './MessengerConfigDialog'
import VoiceBotIcon from '~/icons/VoiceBotIcon'
import BotChatIcon from '~/icons/BotChatIcon'
import { BotChatTemplate } from './BotChatTemplate'
import { TelegramConfigDialog } from './TelegramConfigDialog'
import TelegramIcon from '~/icons/TelegramIcon'
import InfoIcon from '~/icons/InfoIcon'
import { InfoTip } from './InfoTip'
import SmallCloseBtn from '~/icons/smallCloseBtn'
import { InstagramConfigDialog } from './InstagramConfigDialog'


type Props = {
  isOpen: boolean
  existingBots: BotConfig[]
  onCreateBotSuccess: () => void
  toggle: () => void
} & ConnectedProps<typeof connector> &
  RouteComponentProps

// export const sanitizeBotId = (text: string) =>
//   text
//     .toLowerCase()
//     .replace(/\s/g, '-')
//     .replace(/[^a-z0-9_-]/g, '')
//     .substring(0, 50)

export const generateUniqueBotId = () => {
  const timestamp = Date.now()  // Get current UTC timestamp in milliseconds
  const randomChars = 'abcdefghijklmnopqrstuvwxyz0123456789'
  const idLength = 5 // You can adjust the length as needed
  let uniqueId = ''
  for (let i = 0; i < idLength; i++) {
    if (i === 0) {
      // Use the first character to represent the timestamp (base36 encoded)
      uniqueId += timestamp.toString(36)
    } else {
      const randomIndex = Math.floor(Math.random() * randomChars.length)
      uniqueId += randomChars.charAt(randomIndex)
    }
  }
  return uniqueId
}
interface SelectOption<T> {
  label: string
  value: T
  __isNew__?: boolean
}

interface botStartupForm {
  title: string
  name: boolean
  phoneNumber?: boolean
  email?: boolean
}

interface State {
  botId: string
  botName: string
  isProcessing: boolean
  // generateId: boolean
  error: any
  templates: any
  categories: SelectOption<string>[]
  selectedTemplate?: BotTemplate
  selectedCategory?: SelectOption<string>
  goToChannelPage: boolean
  goToCreatePage: boolean
  goToCredsPage: boolean
  avatarUrl: string
  avatarPreview: string
  widgetIconUrl: string
  widgetIconPreview: string
  chatTheme: chatTheme
  isChatOpen: boolean
  isAudioEnabled: boolean
  isVideoEnabled: boolean
  isVoiceBotEnabled: boolean
  isWhatsappEnabled: boolean
  isRcsEnabled: boolean
  isFacebookEnabled: boolean
  isInstagramEnabled: boolean
  isTelegramEnabled: boolean
  messaging?: MessagingConfig
  voice_access: boolean
  goToTemplatesPage: boolean
  availableVoiceBotNumbers: any[]
  selectedPhoneNumber: {
    label: string
    value: string
  }
  voiceBotLanguages: any
  voiceBotLanguage: any
  voice_bot_phone_id: string
  voice_bot_phone_number: string
  clickToCallEnabled: boolean
  clickToCallOptions: any
  clickToCall: any
  availableProjects: any[]
  allProjects: any[]
  activeServicesArr: any[]
  selectedProject: enablexProject
  isDialogOpen: boolean
  isWebClientConfigDropdownOpen: boolean
  isProjectsDropdownOpen: boolean
  isMessengerDropdownOpen: boolean
  isInstagramDropdownOpen: boolean
  isTelegramDropdownOpen: boolean
  selfTriggeredBot: boolean
  startupForm: botStartupForm
  startup_message: string
  composerPlaceholder: string
  activeIndex: number
  refBotName: React.RefObject<any>
}

interface enablexProject {
  app_id: string
  app_key: string
  app_name: string
  low_code_url: string
  wa_phone_number: string
  wa_business_name: string
  rcs_phone_number: string
  voice_phone_number: string
  whatsapp: boolean
  rcs: boolean
  video: boolean
  audio: boolean
  roomSettings?: any   // It is not used , Kept it for fallback only
  roomSetting?: any
}
const voiceBotLanguages = ['english', 'hindi']
const clickToCallOptions = ['video', 'voice']

const defaultState = {
  botId: '',
  botName: '',
  startup_message: '',
  selectedCategory: undefined,
  selectedTemplate: undefined,
  error: undefined,
  isProcessing: false,
  // generateId: true,
  goToCreatePage: true,
  availableVoiceBotNumbers: [],
  selectedPhoneNumber: {
    label: '',
    value: ''
  },
  voiceBotLanguages: {label: '', value: ''},
  voiceBotLanguage: voiceBotLanguages[0],
  voice_bot_phone_id: '',
  voice_bot_phone_number: '',
  clickToCallEnabled: false,
  clickToCallOptions: { value: '', label: '' },
  clickToCall: clickToCallOptions[0],
  availableProjects: [],
  allProjects: [],
  activeServicesArr: [],
  messaging: {
    channels: {
      messenger: {
        enabled: false,
        appId: '',
        appSecret: '',
        verifyToken: '',
        pageId: '',
        accessToken: ''
      },
      instagram: {
        enabled: false,
        appId: '',
        appSecret: '',
        verifyToken: '',
        pageId: '',
        accessToken: ''
      }
    }
  },
  selectedProject: {
    app_id: '',
    app_key: '',
    low_code_url: '',
    app_name: '',
    wa_phone_number: '',
    wa_business_name: '',
    rcs_phone_number: '',
    voice_phone_number: '',
    whatsapp: false,
    rcs: false,
    video: false,
    audio: false
  },
  goToChannelPage: false,
  goToCredsPage: false,
  goToTemplatesPage: false,
  avatarUrl: '',
  avatarPreview: '',
  widgetIconUrl: '',
  widgetIconPreview: '',
  composerPlaceholder: 'Say something...',
  chatTheme: {
    theme: '#1d6c90',
    user: {
      bubble: '#1d6c90',
      text: '#333333'
    },
    bot: {
      bubble: '#ffffff',
      text: '#333333'
    },
    widget: {
      variant: 'soft',
      radius: 16,
      position: 'right',
      bubble: '#1d6c90'
    }
  },
  isChatOpen: true,
  isAudioEnabled: false,
  isVideoEnabled: false,
  isVoiceBotEnabled: false,
  isWhatsappEnabled: false,
  isRcsEnabled: false,
  isFacebookEnabled: false,
  isInstagramEnabled: false,
  isTelegramEnabled: false,
  voice_access: false,
  isDialogOpen: false,
  isWebClientConfigDropdownOpen: false,
  isProjectsDropdownOpen: false,
  isMessengerDropdownOpen: false,
  isInstagramDropdownOpen: false,
  isTelegramDropdownOpen: false,
  selfTriggeredBot: false,
  startupForm: {title: '', name: false, phoneNumber: false, email: false},
}

class NewBot extends Component<Props, State> {
  private _form: HTMLFormElement | null = null

  state: State = {
    templates: [],
    categories: [],
    activeIndex: 1,
    refBotName: React.createRef(),
    ...defaultState
  }

  createDropdowns(OptionArray) {
    return OptionArray.map((x) => ({
      label: x.charAt(0).toUpperCase() + x.slice(1),
      value: x
    }))
  }

  componentDidMount() {
    this.loadCategories()
    this.loadTemplates()
    this.fetchProjectsWithoutServices()
    .then(() => console.log('Projects fetched successfully'))
    .catch(error => console.error('Error fetching projects:', error))
    const voiceBotLang = this.createDropdowns(voiceBotLanguages)
    const clickToCallOptionsList = this.createDropdowns(clickToCallOptions)
    this.setState({
      voiceBotLanguages: voiceBotLang,
      voiceBotLanguage: voiceBotLang[0],
      clickToCallOptions: clickToCallOptionsList,
      clickToCall: clickToCallOptionsList[0]
    })
  }

  componentDidUpdate(prevProps: Props) {
    if (!prevProps.botTemplatesFetched && this.props.botTemplatesFetched) {
      this.loadTemplates()
    }
    if (!prevProps.botCategoriesFetched && this.props.botCategoriesFetched) {
      this.loadCategories()
    }
  }

  loadCategories() {
    if (!this.props.botCategoriesFetched) {
      return this.props.fetchBotCategories()
    }

    const categories = this.props.botCategories.map(x => ({ value: x, label: x }))
    this.setState({ categories, selectedCategory: undefined })
  }

  loadTemplates() {
    if (!this.props.botTemplatesFetched) {
      return this.props.fetchBotTemplates()
    }
    const templatesByModule = _.groupBy(this.props.botTemplates, 'moduleName')
    const groupedOptions = _.toPairs(templatesByModule).map(g => ({ label: g[0], options: g[1] }))
    this.setState({ templates: groupedOptions, selectedTemplate: undefined })
  }

  handleNameChanged = (e) => {
    let botName = e.target.value
    // Trim leading spaces only when the input is empty or only contains spaces
   // If the input has no characters yet, trim only leading spaces
    if (!/\S/.test(botName)) {
      botName = botName.trimStart()
    }

    this.setState({
      botName,
      botId: generateUniqueBotId(),
    })
  }

  // handleBotIdChanged = e => this.setState({ botId: sanitizeBotId(e.target.value), generateId: false })

  createBot = async (e: any) => {
    const axios = api.getSecured({ useV1: false })
    e.preventDefault()
    if (this.isButtonDisabled) {
      return
    }
    this.setState({ isProcessing: true })

    const newBot = {
      id: this.state.botId,
      chatTheme: this.state.chatTheme,
      name: this.state.botName,
      startup_message: this.state.startup_message,
      startupForm: this.state.startupForm,
      selfTriggeredBot: this.state.selfTriggeredBot,
      template: _.pick(this.state.selectedTemplate, ['id', 'moduleId']),
      category: this.state.selectedCategory && this.state.selectedCategory.value,
      voiceBotLanguage: this.state.voiceBotLanguage.value || 'english',
      clickToCall: this.state.clickToCallEnabled ? this.state.clickToCall.value : 'text',
    }

    try {
      const response = await api.getSecured({ timeout: ms('2m') }).post('/admin/workspace/bots', newBot)
      if (!response.data || !response.data.payload) {
        this.resetForm()
        return
      }
      const botId = response.data.payload.botId
      this.onCreateBotSuccess()
      const bot_details = {
        selectedProject: {
          app_id: '',
          app_key: '',
          low_code_url: '',
          app_name: '',
          wa_phone_number: '',
          wa_business_name: '',
          rcs_phone_number: '',
          voice_phone_number: '',
          whatsapp: false,
          rcs: false,
          video: false,
          audio: false
        },
        messaging: {
          channels: {
            messenger: {
              version: '1.0.0',
              enabled: false,
              appId: '',
              appSecret: '',
              verifyToken: '',
              pageId: '',
              accessToken: ''
            },
            instagram: {
              version: '1.0.0',
              enabled: false,
              appId: '',
              appSecret: '',
              verifyToken: '',
              pageId: '',
              accessToken: ''
            },
            telegram: {
              version: '1.0.0',
              enabled: false,
              botToken: ''
            }
          }
        },
        avatarUrl: '',
        widgetIconUrl: '',
        isVoiceBotEnabled: false,
        isWhatsappEnabled: false,
        isRcsEnabled: false,
        isFacebookEnabled: false,
        isInstagramEnabled: false,
        isTelegramEnabled: false,
        isVideoEnabled: false,
        isAudioEnabled: false
      }
      let channel_payload: any = {
        channels: {}
      }
      // link avatar

      if (this.state.avatarUrl) {
        const formData = new FormData()
        formData.append('file', this.state.avatarUrl)
        const { data } = await axios.post(`admin/workspace/bots/${botId}/uploadImage`, formData)
        const outputPath = data.payload.fileUrl.replace('/data', '/api/v1')
        bot_details.avatarUrl = outputPath
      }
      if (this.state.widgetIconUrl) {
        const formData = new FormData()
        formData.append('file', this.state.widgetIconUrl)
        const { data } = await axios.post(`admin/workspace/bots/${botId}/uploadImage`, formData)
        const outputPath = data.payload.fileUrl.replace('/data', '/api/v1')
        bot_details.widgetIconUrl = outputPath
      }
      if (!this.state.isWhatsappEnabled && !this.state.isVideoEnabled && !this.state.isAudioEnabled && !this.state.isVoiceBotEnabled) {
        this.setState({
          selectedProject: {
            app_id: '',
            app_key: '',
            app_name: '',
            low_code_url: '',
            wa_phone_number: '',
            wa_business_name: '',
            rcs_phone_number: '',
            voice_phone_number: '',
            whatsapp: false,
            rcs: false,
            video: false,
            audio: false
          }
        })
      }
      let messenger_payload = {}
      let messengerConfig = this.state?.messaging?.channels?.messenger
      if (messengerConfig && messengerConfig?.appId && messengerConfig?.appSecret && messengerConfig?.verifyToken && messengerConfig?.pageId && messengerConfig?.accessToken) {
        messenger_payload = messengerConfig
        bot_details.isFacebookEnabled = this.state.isFacebookEnabled
        bot_details.messaging.channels.messenger = messengerConfig
      } else {
        bot_details.isFacebookEnabled = false
      }
      if(this.state.isFacebookEnabled) {
        channel_payload.channels.messenger = messenger_payload
      }

      let instagram_payload = {}
      let instagramConfig = this.state?.messaging?.channels?.instagram
      if (instagramConfig && instagramConfig?.appId && instagramConfig?.appSecret && instagramConfig?.verifyToken && instagramConfig?.pageId && instagramConfig?.accessToken) {
        instagram_payload = instagramConfig
        bot_details.isInstagramEnabled = this.state.isInstagramEnabled
        bot_details.messaging.channels.instagram = instagramConfig
      } else {
        bot_details.isInstagramEnabled = false
      }
      if(this.state.isInstagramEnabled) {
        channel_payload.channels.instagram = instagram_payload
      }

      let telegram_payload = {}
      let telegramConfig = this.state?.messaging?.channels?.telegram
      if (telegramConfig && telegramConfig?.botToken) {
        telegram_payload = telegramConfig
        bot_details.isTelegramEnabled = this.state.isTelegramEnabled
        bot_details.messaging.channels.telegram = telegramConfig
      } else {
        bot_details.isTelegramEnabled = false
      }
      if(this.state.isTelegramEnabled) {
        channel_payload.channels.telegram = telegram_payload
      }

      // link project
      if (this.state.selectedProject.app_id.length > 0) {
        const payload = {
          botName: this.state.botName,
          projectId: this.state.selectedProject.app_id,
          services: {
            whatsapp: this.state.isWhatsappEnabled,
            rcs: this.state.isRcsEnabled,
            video: this.state.isVideoEnabled,
            voice: this.state.isAudioEnabled || this.state.isVoiceBotEnabled
          }
        }
        const { data } = await axios.post(`admin/workspace/bots/${botId}/linkProject`, payload)

        if (data.result === 1) {
          // eslint-disable-next-line no-console
          // console.log(`Project ${this.state.selectedProject.app_name} linked with bot ${botId} `)
          bot_details.selectedProject = this.state.selectedProject
          bot_details.isVoiceBotEnabled = this.state.isVoiceBotEnabled
          bot_details.isWhatsappEnabled = this.state.isWhatsappEnabled
          bot_details.isRcsEnabled = this.state.isRcsEnabled
          bot_details.isVideoEnabled = this.state.isVideoEnabled
          bot_details.isAudioEnabled = this.state.isAudioEnabled
          const whatsapp_payload = {
            appId: this.state.selectedProject.app_id,
            appKey: this.state.selectedProject.app_key
          }
          const rcs_payload = {
            appId: this.state.selectedProject.app_id,
            appKey: this.state.selectedProject.app_key
          }
          const audio_video_payload = {
            appId: this.state.selectedProject.app_id,
            appKey: this.state.selectedProject.app_key,
            lowCodeUrl: this.state.selectedProject.low_code_url
          }
          if(this.state.isWhatsappEnabled) {
            channel_payload.channels.whatsapp = whatsapp_payload
          }
          if(this.state.isRcsEnabled) {
            channel_payload.channels.rcs = rcs_payload
          }
          if(this.state.isVoiceBotEnabled) {
            const voiceBot_payload = {
              appId: this.state.selectedProject.app_id,
              appKey: this.state.selectedProject.app_key,
              phoneNumber: this.state.voice_bot_phone_number,
              phoneID: this.state.voice_bot_phone_id
            }
            channel_payload.channels.voice = voiceBot_payload
          }
          if (this.state.isVideoEnabled) {
            await this.updateNowBotServices(botId, 'enableService', 'video', audio_video_payload)
          } else {
            await this.updateNowBotServices(botId, 'disableService', 'video', {})
          }
          if (this.state.isAudioEnabled) {
            await this.updateNowBotServices(botId, 'enableService', 'audio', audio_video_payload)
          } else {
            await this.updateNowBotServices(botId, 'disableService', 'audio', {})
          }
        } else {
          console.error(`Project not linked with bot ${botId} error: ${data.message}`)
          this.setState({
            selectedProject: {
              app_id: '',
              app_key: '',
              app_name: '',
              low_code_url: '',
              wa_phone_number: '',
              wa_business_name: '',
              rcs_phone_number: '',
              voice_phone_number: '',
              whatsapp: false,
              rcs: false,
              video: false,
              audio: false
            }
          })
        }
      }
      await this.updateNowBotChannels(botId, channel_payload)
      if (bot_details.avatarUrl.length > 0 || this.state.selectedProject.app_id.length > 0 || bot_details.messaging?.channels?.messenger?.appId || bot_details.messaging?.channels?.instagram?.appId || bot_details.messaging?.channels?.telegram?.botToken) {
        const { data } = await axios.post(`admin/workspace/bots/${botId}/updateDetails`, bot_details)
      }
      this.resetForm()
    } catch (error) {
      this.setState({ error: error.message, isProcessing: false })
    }
  }

  goToCreateFormPage() {
    this.state.activeIndex = 1
    this.setState({ goToCreatePage: true, goToChannelPage: false, goToCredsPage: false, goToTemplatesPage: false })
  }

  async goToSelectChannelPage() {
    this.state.activeIndex = 2
    const voice_access = await this.getVoiceAccessStatus()
    this.setState({ voice_access })

    this.setState({ goToCreatePage: false, goToChannelPage: true, goToCredsPage: false, goToTemplatesPage: false })
  }

  removeRepetitionsAndTrim = (array: string[]) => {
    let uniqueArray: string[] = []
    for (let i = 0; i < array.length; i++) {
      let currentItem: string = array[i].trim()
      if (!uniqueArray.includes(currentItem)) {
        uniqueArray.push(currentItem)
      }
    }
    return uniqueArray
  }

  getRequiredServices() {
    const enabled_services: string[] = []
    if (this.state.isVoiceBotEnabled) {
      enabled_services.push('voice')
    }
    if (this.state.isWhatsappEnabled) {
      enabled_services.push('whatsapp')
    }
    if (this.state.isRcsEnabled) {
      enabled_services.push('rcs')
    }
    if (this.state.isVideoEnabled) {
      enabled_services.push('video')
    }
    if (this.state.isAudioEnabled) {
      enabled_services.push('voice')
      enabled_services.push('video')
    }
    return this.removeRepetitionsAndTrim(enabled_services).join(',')
  }

  getEnableXServices() {
    const enabled_services: string[] = []
    if (this.state.isVoiceBotEnabled) {
      enabled_services.push('Voice bot')
    }
    if (this.state.isWhatsappEnabled) {
      enabled_services.push('WhatsApp')
    }
    if (this.state.isRcsEnabled) {
      enabled_services.push('RCS')
    }
    if (this.state.isVideoEnabled) {
      enabled_services.push('Video')
    }
    if (this.state.isAudioEnabled) {
      enabled_services.push('Phone')
    }
    return this.removeRepetitionsAndTrim(enabled_services).join(', ')
  }

  createNumberOptions(numbers: any) {
    let options: {label: string; value: string}[] = []
    for(const key in numbers){
      let label = numbers[key]
      let value = key
      options.push({label, value})
    }
    return options
  }

  async showProjectList(requiredServices) {
    const axios = api.getSecured({ useV1: false })
    const { data } = await axios.get(`admin/workspace/bots/getProjects/${requiredServices}`)
    // eslint-disable-next-line no-console
    // console.log('Fetched projects:', data)
    if (data.result) {
      if (data.projects.length > 0) {
        this.setState({ availableProjects: data.projects })
      } else {
        this.setState({availableProjects: []})
      }
    }
  }
  extractUniqueServices = (projects) => {
    const validServices = ['voice', 'whatsapp', 'video']
    const activeServicesSet = new Set()
    projects.forEach(project => {
      Object.entries(project.services_incl).forEach(([service, isActive]) => {
        if (isActive && validServices.includes(service)) {
          activeServicesSet.add(service)
        }
      })
    })
    return Array.from(activeServicesSet)
  }
  async fetchProjectsWithoutServices() {
    const axios = api.getSecured({ useV1: false })
    const { data } = await axios.get('admin/workspace/bots/getAllProjectsUnderWorkSpace')
    console.log('fetchProjectsWithoutServices', data)
    if (data.result) {
      if (data.projects.length > 0) {
        const activeServicesArr = this.extractUniqueServices(data.projects)
        console.log('activeServicesArr',activeServicesArr)
        this.setState({ allProjects: data.projects })
        this.setState({activeServicesArr})
      } else {
        this.setState({allProjects: []})
        this.setState({ activeServicesArr: []})
      }
    }
  }


  async getVoiceAccessStatus(): Promise<boolean> {
    const axios = api.getSecured({ useV1: false })
    const { data } = await axios.get('admin/workspace/bots/voiceAccessStatus')
    return data.result
  }

  async updateNowBotServices(botId, service_action, service, payload) {
    const axios = api.getSecured({ useV1: false })
    await axios.post(`admin/workspace/bots/${botId}/${service_action}/${service}`, payload)
  }

  async updateNowBotChannels(botId, payload) {
    const axios = api.getSecured({ useV1: false })
    await axios.post(`admin/workspace/bots/${botId}/updateChannels`, payload)
  }

  onCreateBotSuccess() {
    this.props.fetchBots()
    toast.success('admin.workspace.bots.created_successful', this.state.botName)
  }

  toggle() {
    this.setState({ ...defaultState })
  }

  goToEnterCredsPage() {
    const required_services = this.getRequiredServices()
    console.log('required_services',required_services)
    const { isVideoEnabled, isWhatsappEnabled, isVoiceBotEnabled, allProjects } = this.state
    const requiredServices: Record<string, boolean> = {}
    if (isVideoEnabled) {
      requiredServices.video = true
    }
    if (isWhatsappEnabled) {
      requiredServices.whatsapp = true
    }
    if (isVoiceBotEnabled) {
      requiredServices.voice = true
    }
    console.log('requiredServices',requiredServices)
    if (Object.keys(requiredServices).length > 0) {
      // Check if there's any project that contains all required services
      const matchingProject = allProjects.some(project => {
        return Object.entries(requiredServices).every(([service]) => {
          return project.services_incl[service] === true
        })
      })
      console.log('matchingProject',matchingProject)
      if (!matchingProject) {
        // alert('No project matches the selected services. Please select different services or create a new project.')
        this.setState({ error: 'No project matches the selected services. Please select different services or create a new project.', isProcessing: false })
        return
      }else{
        this.setState({ error: '', isProcessing: false })
      }
    }
    this.state.activeIndex = 3
    if (required_services.length) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.showProjectList(required_services)
      this.setState({ goToCreatePage: false, goToChannelPage: false, goToCredsPage: true, goToTemplatesPage: false })
    } else {
      this.setState({ goToCreatePage: false, goToChannelPage: false, goToCredsPage: true, goToTemplatesPage: false })
    }
  }

  goToEnterCredsPageBack() {
    const required_services = this.getRequiredServices()
    this.state.activeIndex = 3
    if (required_services.length) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.showProjectList(required_services)
      this.setState({ goToCreatePage: false, goToChannelPage: false, goToCredsPage: true, goToTemplatesPage: false })
    } else {
      this.setState({ goToCreatePage: false, goToChannelPage: false, goToCredsPage: true, goToTemplatesPage: false })
    }
  }

  // gotoPreviewLink() {
  // }

  isOnlySpecialCharacter(input) {
    // Regular expression to check if the bot name consists only of special characters
    const specialCharOnlyRegex = /^[^a-zA-Z0-9]*$/
    if (specialCharOnlyRegex.test(input)) {
      return true
    }
    return false
  }

  gotToSelectTemplatePage() {
    // Skip all channel-related validations and go directly to template selection
    this.state.activeIndex = 4
    this.setState({ goToCreatePage: false, goToChannelPage: false, goToCredsPage: false, goToTemplatesPage: true })
    if (this.state.templates.length > 0 && this.state.templates[0].options.length > 0) {
      this.handleTemplateSelection(this.state.templates[0].options[0])
    }
  }

  resetForm = () => {
    this.setState({ ...defaultState })
    this.props.history.push(
      generatePath('/workspace/:workspaceId?/bots', {
        workspaceId: getActiveWorkspace() || undefined
      })
    )
  }

  get isButtonDisabled() {
    const { isProcessing, botId, botName } = this.state
    // Check if botName contains at least one alphanumeric character
    const hasAlphanumeric = /[a-zA-Z0-9]/.test(botName)
    const isBotNameInvalid = !botName || !hasAlphanumeric
    const isNameOrIdInvalid =
      isBotNameInvalid ||
      !botId ||
      !botName ||
      (this.props.existingBots && this.props.existingBots.some(bot => bot.name === botName || bot.id === botId))
    return isNameOrIdInvalid || isProcessing || !this._form || !this._form.checkValidity()
  }

  handleAudioCallingChange() {
    if(this.state.voice_access) {
      this.setState(prevState => {
        return { isAudioEnabled: !prevState.isAudioEnabled }
      })
    }
  }

  handleVideoCallingChange() {
    this.setState(prevState => {
      return { isVideoEnabled: !prevState.isVideoEnabled }
    })
  }

  handleTemplateSelection(item) {
    this.setState({ selectedTemplate: item as any })
  }
  handleWebSelection() { }

  convertFileToDataURL(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()

      reader.onload = function (event) {
        resolve(event?.target?.result)
      }

      reader.onerror = function (error) {
        reject(error)
      }

      reader.readAsDataURL(file)
    })
  }

  setFileName(filename) {
    // eslint-disable-next-line no-console
    // console.log('filename: ', filename[0])
    this.convertFileToDataURL(filename).then((dataURL: any): any => {
      this.setState({ avatarUrl: filename, avatarPreview:  dataURL })
      // You can now use the data URL as needed
    }).catch(error => {
      console.error('Error converting file to data URL:', error)
    })
  }

  deleteFileName() {
    this.setState({avatarUrl: ''})
    this.setState({avatarPreview: ''})
  }

  handleWhatsAppSelection() {
    this.setState(prevState => {
      return { isWhatsappEnabled: !prevState.isWhatsappEnabled }
    })
  }

  handleRcsSelection() {
    this.setState(prevState => {
      return { isRcsEnabled: !prevState.isRcsEnabled }
    })
  }

  handleVoiceBotSelection() {
    this.setState(prevState => {
      return { isVoiceBotEnabled: !prevState.isVoiceBotEnabled }
    })
  }

  handleFacebookSelection() {
    this.setState(prevState => {
      return { isFacebookEnabled: !prevState.isFacebookEnabled }
    })
  }

  handleInstagramSelection() {
    this.setState(prevState => {
      return { isInstagramEnabled: !prevState.isInstagramEnabled }
    })
  }

  handleTelegramSelection() {
    this.setState(prevState => {
      return { isTelegramEnabled: !prevState.isTelegramEnabled }
    })
  }

  showPreview() {
    this.setState({ isDialogOpen: !this.state.isDialogOpen })
  }

  async onSubmit(e) {
    e.preventDefault()
    if(this.state.activeIndex === 1 && this.state.refBotName?.current?.props.value.length >= this.state.refBotName?.current?.props.minLength) {
      this.gotToSelectTemplatePage()
    }
  }

  toggleChat() {
    this.setState((prevState) => ({
      isChatOpen: !prevState.isChatOpen
    }))
  }

  handleWebClientDropdownClick = () => {
    this.setState({ isWebClientConfigDropdownOpen: !this.state.isWebClientConfigDropdownOpen })
  }
  handleProjectsDropdownClick() {
    this.setState({ isProjectsDropdownOpen: !this.state.isProjectsDropdownOpen })
  }
  handleTelegramDropdownClick() {
    this.setState({ isTelegramDropdownOpen: !this.state.isTelegramDropdownOpen })
  }
  handleMessengerDropdownClick = () => {
    this.setState({ isMessengerDropdownOpen: !this.state.isMessengerDropdownOpen })
  }
  handleInstagramDropdownClick = () => {
    this.setState({ isInstagramDropdownOpen: !this.state.isInstagramDropdownOpen })
  }

  handleInputSelfTriggeredBot = (event) => {
    // @ts-ignore
    if(event.target.checked === false) {
      this.setState({ selfTriggeredBot: false})
    } else {
    this.setState({ selfTriggeredBot: true })
    }
  }

  handleInputChangedUserData = (event) => {
    // @ts-ignore
    if(event.target.name === 'name' && event.target.checked === false) {
      this.setState({ startupForm: {title: this.state.startupForm.title, name: false, phoneNumber: false, email: false}})
    } else {
      if(!this.state.clickToCallEnabled) {
        this.setState({ startupForm: {...this.state.startupForm, [event.target.name]: event.target.checked} })
      } else {
        toast.failure('Please disable click to call to enable collect user information.')
      }
    }
  }

  handleClickToCallChange = (event) => {
    // @ts-ignore
    if(!event.target.checked) {
      this.setState({ clickToCallEnabled: false})
    } else {
      if(!this.state.startupForm.name) {
        this.setState({ clickToCallEnabled: true })
      } else {
        toast.failure('Please disable collect user information to enable click to call.')
      }
    }
  }

  handleInputChangedUserDataTitle = (event) => {
    // @ts-ignore
    this.setState({ startupForm: {...this.state.startupForm, [event.target.name]: event.target.value} })
  }

  handleInputChanged = (event) => {
    // @ts-ignore
    this.setState({ [event.target.name]: event.target.value })
    if(event.target.name === 'startup_message') {
      this.setState({isChatOpen: false})
    }
  }

  handleVoiceBotLanguageChange = (voiceBotLanguage) => {
    this.setState({ voiceBotLanguage })
  }

  handleClickToCallOptionChange = (clickToCallOption) => {
    this.setState({ clickToCall: clickToCallOption })
  }

  render() {
    if (!this.props.bots) {
      return <LoadingSection />
    }

    const SectionHeading = ({heading, description}: any) => {
      return <>
        { heading && <p className={style.subHeading}>{heading}</p> }
        { description && <p className={style.subHeadingDescription}>{description}</p> }
      </>
    }

    const setChatTheme = (chatTheme: chatTheme) => {
      this.setState({ chatTheme })
    }

    const toggleChat = () => {
      this.setState((prevState) => ({
        isChatOpen: !prevState.isChatOpen
      }))
    }

    return (
      <PageContainer title={lang.tr('admin.workspace.bots.bots')} contentClassName={style.pageContentContainer}>
        <Fragment>
          <div className={style.botTopTitle}>
            <h3 className={style.newBotBreadCrumb}>
              <span>
              BOTs / <span className={style.activeSection}>Create a New BOT</span>
              </span>
              <span> {this.state.activeIndex === 4 ? '3' : this.state.activeIndex} /3</span>
            </h3>
          </div>
          <div className={style.botFormContainerWrapper}>
            <div className={style.botFormContainer} style={this.state.activeIndex === 3 ? {height: '100%'} : {}}>
              <form style={this.state.activeIndex === 3 ? {height: '100%'} : {}} ref={form => (this._form = form)} onSubmit={this.onSubmit.bind(this)}>
                {/* Create bot form */}
                {this.state.goToCreatePage && (
                  <div className={`${style.newBotContainer} ${style.botInitialConfig}`}>
                    <div className={style.stepTitle}>Set Up Your New Bots</div>
                    <p className={style.stepSubTitle}>Provide its name and choose a profile image.</p>
                    <div className={style.botNameForm}>
                      <div className={style.botName} style={{ display: 'flex', flexDirection: 'column' }}>
                        <div>
                          <FormGroup
                            label={lang.tr('admin.workspace.bots.create.name')}
                            labelFor="bot-name"
                            labelInfo="*"
                            helperText={lang.tr('admin.workspace.bots.create.nameHelper')}
                          >
                            <InputGroup
                              ref={this.state.refBotName}
                              id="input-bot-name"
                              tabIndex={1}
                              placeholder={lang.tr('admin.workspace.bots.create.namePlaceholder')}
                              minLength={3}
                              maxLength={50}
                              required
                              value={this.state.botName}
                              onChange={this.handleNameChanged.bind(this)}
                              autoFocus
                            />
                          </FormGroup>
                          <div
                            className={style.botAvatar}
                            style={{ overflow: 'hidden', display: 'flex', paddingBottom: '20px' }}
                          >
                            <div style={{ width: '100%', minWidth: '275px' }}>
                              <label>Select a profile image</label>
                              <p style={{ marginTop: '5px', color: '#333', fontSize: '14px', paddingBottom: '10px', fontFamily: 'Barlow Medium' }}>
                                This image will be the face of your bot, embodying its identity. Drag and drop an associated
                                image here.
                              </p>
                              <DropzoneComponent selectedImage={this.state.avatarPreview} botAvatar={this.setFileName.bind(this)} handleDeleteFileName={this.deleteFileName.bind(this)}/>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', gridRow: '1/4'}}>
                        {
                          !this.state.isChatOpen ?
                          <button
                            className={'bpw-widget-btn bpw-floating-button'}
                            style={{backgroundColor: `${this.state.chatTheme?.theme}`, position: 'absolute', bottom: '16px', right: '16px'}}
                            onClick={this.toggleChat.bind(this)}
                          >
                            <BotChatIcon />
                          </button> : <BotChatTemplate parentProps={this} toggleChat={this.toggleChat.bind(this)} />
                        }
                      </div>
                      <div className={style.nextButton}>
                        {/* {!!this.state.error && <Callout intent={Intent.DANGER}>{this.state.error}</Callout>} */}
                        <div className={style.buttonGroup}>
                                                  <Button
                          id="btn-modal-create-bot"
                          type="button"
                          text={this.state.isProcessing ? lang.tr('pleaseWait') : lang.tr('admin.next')}
                          onClick={this.gotToSelectTemplatePage.bind(this)}
                          disabled={this.isButtonDisabled}
                          intent={Intent.PRIMARY}
                          large={true}
                        />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Channel Selection */}
                {this.state.goToChannelPage && (
                  <div className={style.newBotContainer} style={this.state.activeIndex === 3 ? {height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between'} : {}}>
                    <div className={style.stepTitle}>Select Communication Channel(s) for Your Bot</div>
                    <div style={{ marginTop: '5px', color: '#5c7080', fontSize: '13px', paddingBottom: '10px' }}>
                      {/* <p>Select the communication channel(s) for your bot.</p> */}
                      {/* <strong>Information:</strong> */}
                      {/* <ul className={style.stepSubTitle} style={{paddingLeft: 0, listStyle: 'none', marginBottom: 0}}>
                        <li>• Web is the default channel and will always be active for your bot.</li>
                        <li>• Ensure your desired channels are activated in your CPaaS project before selecting here.</li>
                      </ul> */}
                    </div>
                    <div style={{paddingBottom: '40px'}}>
                      <h2 style={{marginBottom: 0}}>Chatbot Interaction Channels</h2>
                      <p style={{marginBottom: '10px', fontSize: 'medium', color: '#969696'}}>Choose the channel where you want to deploy your chatbot</p>
                      <div className={`${style.botChannels} ${style.mainChannels}`}>
                        {/* WebChat */}
                        <div
                          className={cx(style.botChannel, 'channel-selected')}
                          onClick={this.handleWebSelection.bind(this)}
                          id="web"
                        >
                          <div className={style.channelIcon}>
                            <Checkbox className={style.checkboxCss} checked={true}/>
                            <div className={style.infoToolTip}>
                              <Popover
                                position={PopoverPosition.TOP}
                                interactionKind={'hover'}
                                content={<div style={{width: '300px', padding: '10px'}}>{lang.tr('admin.workspace.bots.create.webChatText')}</div>}
                              >
                                <Icon icon={<InfoIcon />} iconSize={14} />
                              </Popover>
                            </div>
                            <div className={style.channelSvgIcon}>
                              <WebChatIcon />
                            </div>
                            <p style={{ fontSize: '14px', fontWeight: 600 }}>Web Chat</p>
                          </div>
                          {/* <div>{lang.tr('admin.workspace.bots.create.webChatText')}</div> */}
                        </div>
                        {/* WhatsApp */}
                        <div
                          className={cx(style.botChannel, this.state.isWhatsappEnabled ? 'channel-selected' : '',
                               this.state.activeServicesArr.includes('whatsapp') ? '' : 'channel-disabled'
                          )}
                          onClick={this.state.activeServicesArr.includes('whatsapp') ? this.handleWhatsAppSelection.bind(this) : () => {}}
                          id="whatsapp"
                        >
                          <div className={style.channelIcon}>
                            <Checkbox className={style.checkboxCss} checked={this.state.isWhatsappEnabled} onChange={this.handleWhatsAppSelection.bind(this)}/>
                            <div className={style.infoToolTip}>
                              <Popover
                                position={PopoverPosition.TOP}
                                interactionKind={'hover'}
                                content={<div style={{width: '300px', padding: '10px'}}><span>{lang.tr('admin.workspace.bots.create.whatsAppText')}</span>{!this.state.isWhatsappEnabled && <><br></br> <span style={{color: '#db3737'}}>Note: This functionality is not available in your selected Workspace</span></> }</div>}
                              >
                                <Icon icon={<InfoIcon />} iconSize={14} />
                              </Popover>
                            </div>
                            <div className={style.channelSvgIcon}>
                              <WhatsAppIcon />
                            </div>
                            <p style={{ fontSize: '14px', fontWeight: 600 }}>WhatsApp</p>
                          </div>
                          {/* <div>{lang.tr('admin.workspace.bots.create.whatsAppText')}</div> */}
                        </div>
                        {/* RCS */}
                        <div
                          className={cx(style.botChannel, this.state.isRcsEnabled ? 'channel-selected' : '',
                               this.state.activeServicesArr.includes('rcs') ? '' : 'channel-disabled'
                          )}
                          onClick={this.state.activeServicesArr.includes('rcs') ? this.handleRcsSelection.bind(this) : () => {}}
                          id="rcs"
                        >
                          <div className={style.channelIcon}>
                            <Checkbox className={style.checkboxCss} checked={this.state.isRcsEnabled} onChange={this.handleRcsSelection.bind(this)}/>
                            <div className={style.infoToolTip}>
                              <Popover
                                position={PopoverPosition.TOP}
                                interactionKind={'hover'}
                                content={<div style={{width: '300px', padding: '10px'}}><span>{lang.tr('admin.workspace.bots.create.rcsText')}</span>{!this.state.isRcsEnabled && <><br></br> <span style={{color: '#db3737'}}>Note: This functionality is not available in your selected Workspace</span></> }</div>}
                              >
                                <Icon icon={<InfoIcon />} iconSize={14} />
                              </Popover>
                            </div>
                            <div className={style.channelSvgIcon}>
                              <RcsIcon />
                            </div>
                            <p style={{ fontSize: '14px', fontWeight: 600 }}>RCS</p>
                          </div>
                          {/* <div>{lang.tr('admin.workspace.bots.create.rcsText')}</div> */}
                        </div>
                        {/* Voice Bot */}
                        <div
                          className={cx(style.botChannel, this.state.isVoiceBotEnabled ? 'channel-selected' : '',
                            this.state.activeServicesArr.includes('voice') ? '' : 'channel-disabled'
                          )}
                          onClick={this.state.activeServicesArr.includes('voice') ? this.handleVoiceBotSelection.bind(this) : () => {}}
                          id="voiceBot"
                        >
                          <div className={style.channelIcon}>
                            <Checkbox className={style.checkboxCss} checked={this.state.isVoiceBotEnabled} onChange={this.handleVoiceBotSelection.bind(this)} />
                            <div className={style.infoToolTip}>
                              <Popover
                                position={PopoverPosition.TOP}
                                interactionKind={'hover'}
                                content={<div style={{width: '300px', padding: '10px'}}><span>{lang.tr('admin.workspace.bots.create.voiceBotText')}</span>{!this.state.isVoiceBotEnabled && <><br></br> <span style={{color: '#db3737'}}>Note: This functionality is not available in your selected Workspace</span></> }</div>}
                              >
                                <Icon icon={<InfoIcon />} iconSize={14} />
                              </Popover>
                            </div>
                            <div className={style.channelSvgIcon}>
                              <VoiceBotIcon />
                            </div>
                            <p style={{ fontSize: '14px', fontWeight: 600 }}>Voice Bot</p>
                          </div>
                          {/* <div>{lang.tr('admin.workspace.bots.create.voiceBotText')}</div> */}
                        </div>
                        {/* Messenger */}
                        {/* <div
                          className={cx(style.botChannel, this.state.isFacebookEnabled ? 'channel-selected' : '')}
                          onClick={this.handleFacebookSelection.bind(this)}
                          id="facebook"
                        >
                          <div className={style.channelIcon}>
                            <Checkbox className={style.checkboxCss} checked={this.state.isFacebookEnabled} onChange={this.handleFacebookSelection.bind(this)} />
                            <div className={style.infoToolTip}>
                              <Popover
                                position={PopoverPosition.TOP}
                                interactionKind={'hover'}
                                content={<div style={{width: '300px', padding: '10px'}}>{lang.tr('admin.workspace.bots.create.facebookText')}</div>}
                              >
                                <Icon icon={<InfoIcon />} iconSize={14} />
                              </Popover>
                            </div>
                            <div className={style.channelSvgIcon}>
                              <FacebookIcon />
                            </div>
                            <p style={{ fontSize: '14px', fontWeight: 600 }}>Messenger</p>
                          </div>
                          <div>{lang.tr('admin.workspace.bots.create.facebookText')}</div>
                        </div> */}
                        {/* Instagram */}
                        {/* <div
                          className={cx(style.botChannel, this.state.isInstagramEnabled ? 'channel-selected' : '')}
                          onClick={this.handleInstagramSelection.bind(this)}
                          id="instagram"
                        >
                          <div className={style.channelIcon}>
                            <Checkbox className={style.checkboxCss} checked={this.state.isInstagramEnabled} onChange={this.handleInstagramSelection.bind(this)} />
                            <div className={style.infoToolTip}>
                              <Popover
                                position={PopoverPosition.TOP}
                                interactionKind={'hover'}
                                content={<div style={{width: '300px', padding: '10px'}}>{lang.tr('admin.workspace.bots.create.instagramText')}</div>}
                              >
                                <Icon icon={<InfoIcon />} iconSize={14} />
                              </Popover>
                            </div>
                            <div className={style.channelSvgIcon}>
                              <InstagramIcon />
                            </div>
                            <p style={{ fontSize: '14px', fontWeight: 600 }}>Instagram</p>
                          </div>
                          <div>{lang.tr('admin.workspace.bots.create.instagramText')}</div>
                        </div> */}
                        {/* Telegram */}
                        {/* <div
                          className={cx(style.botChannel, this.state.isTelegramEnabled ? 'channel-selected' : '')}
                          onClick={this.handleTelegramSelection.bind(this)}
                          id="telegram"
                        >
                          <div className={style.channelIcon}>
                            <Checkbox className={style.checkboxCss} checked={this.state.isTelegramEnabled} onChange={this.handleTelegramSelection.bind(this)} />
                            <div className={style.infoToolTip}>
                              <Popover
                                position={PopoverPosition.TOP}
                                interactionKind={'hover'}
                                content={<div style={{width: '300px', padding: '10px'}}>{lang.tr('admin.workspace.bots.create.TelegramText')}</div>}
                              >
                                <Icon icon={<InfoIcon />} iconSize={14} />
                              </Popover>
                            </div>
                            <div className={style.channelSvgIcon}>
                              <TelegramIcon />
                            </div>
                            <p style={{ fontSize: '14px', fontWeight: 600 }}>Telegram</p>
                          </div>
                        </div> */}
                      </div>
                      <div>
                        <h2 style={{marginBottom: 0}}>Agent Interaction Add-On Channels</h2>
                        <p style={{marginBottom: '10px', fontSize: 'medium', color: '#969696'}}>Select additional agent interaction channels to enhance your support capabilities and improve connectivity with your customers</p>
                        <div className={`${style.botChannels} ${style.agentChannels}`}>
                          {/* Voice Channel */}
                          <div
                            className={cx(
                              style.botChannel,
                              this.state.voice_access
                                ? this.state.isAudioEnabled
                                  ? 'channel-selected'
                                  : ''
                                : 'channel-disabled'
                            )}
                            onClick={this.handleAudioCallingChange.bind(this)}
                            id="audio"
                          >
                            <div className={style.channelIcon}>
                              <Checkbox className={style.checkboxCss} checked={this.state.isAudioEnabled} onChange={this.handleAudioCallingChange.bind(this)} />
                              <div className={style.infoToolTip}>
                                <Popover
                                  position={PopoverPosition.TOP}
                                  interactionKind={'hover'}
                                  content={<div style={{ width: '300px', padding: '10px' }}><span>{lang.tr('admin.workspace.bots.create.phoneCallText')}</span>{!this.state.voice_access && <><br></br> <span style={{color: '#db3737'}}>Note: This functionality is not available in your region</span></> }</div>}
                                >
                                  <Icon icon={<InfoIcon />} iconSize={14} />
                                </Popover>
                              </div>
                              <div className={style.channelSvgIcon}>
                                <PhoneCall />
                              </div>
                              <p style={{ fontSize: '14px', fontWeight: 600 }}>Phone Calling</p>
                            </div>
                            {/* <div>{lang.tr('admin.workspace.bots.create.phoneCallText')}</div> */}
                          </div>
                          {/* Video Channel */}
                          <div
                            className={cx(style.botChannel, this.state.isVideoEnabled ? 'channel-selected' : '',
                              this.state.activeServicesArr.includes('video') ? '' : 'channel-disabled'
                            )}
                            onClick={this.state.activeServicesArr.includes('video') ? this.handleVideoCallingChange.bind(this) : () => {}}
                            id="video"
                          >
                            <div className={style.channelIcon}>
                              <Checkbox className={style.checkboxCss} checked={this.state.isVideoEnabled} onChange={this.handleVideoCallingChange.bind(this)} />
                              <div className={style.infoToolTip}>
                                <Popover
                                  position={PopoverPosition.TOP}
                                  interactionKind={'hover'}
                                  content={<div style={{width: '300px', padding: '10px'}}><span>{lang.tr('admin.workspace.bots.create.videoCallText')}</span>{!this.state.isVideoEnabled && <><br></br> <span style={{color: '#db3737'}}>Note: This functionality is not available in your selected Workspace</span></> }</div>}
                                >
                                  <Icon icon={<InfoIcon />} iconSize={14} />
                                </Popover>
                              </div>
                              <div className={style.channelSvgIcon}>
                                <VideoCall />
                              </div>
                              <p style={{ fontSize: '14px', fontWeight: 600 }}>Video Calling</p>
                            </div>
                            {/* <div>{lang.tr('admin.workspace.bots.create.videoCallText')}</div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={''}>
                      {!!this.state.error && <Callout style={{marginBottom: '30px'}} intent={Intent.DANGER}>{this.state.error}</Callout>}
                      <div className={style.buttonGroup}>
                        <Button
                          id="btn-modal-create-bot"
                          type="button"
                          text={this.state.isProcessing ? lang.tr('pleaseWait') : lang.tr('admin.prev')}
                          onClick={this.goToCreateFormPage.bind(this)}
                          intent={Intent.NONE}
                          large={true}
                        />
                        {this.state.isProcessing ? null : (
                          <Button
                            id="btn-modal-enter-creds"
                            type="button"
                            text={lang.tr('admin.next')}
                            onClick={this.goToEnterCredsPage.bind(this)}
                            intent={Intent.PRIMARY}
                            large={true}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {/* Enter creds */}
                {this.state.goToCredsPage && (
                  <div className={style.newBotContainer} style={this.state.activeIndex === 3 ? {height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between'} : {}}>
                    <div style={{display: 'flex', flexDirection: 'column', overflowY: 'auto', paddingRight: '4px'}}>
                      <div className={style.stepTitle} style={{ paddingBottom: '20px' }}>Configuration</div>
                      <div style={{height: '100%', overflow: 'auto', padding: '0 10px'}}>
                        {
                          <div style={{paddingBottom: '20px'}}>
                            <Button style={this.state.isWebClientConfigDropdownOpen ? {borderRadius: '6px 6px 0 0', background: 'rgba(29, 108, 144, 0.2)', border: '1px solid var(--theme-color)'} : {borderRadius: '6px', background: '#fff', border: '1px solid rgb(151, 151, 151)'}} className={style.collapsible} onClick={this.handleWebClientDropdownClick.bind(this)} rightIcon={this.state.isWebClientConfigDropdownOpen ? 'chevron-up' : 'chevron-down'}>
                              <WebChatIcon /> Web Client
                            </Button>
                            <Collapse className={style.webClientCollapsible} isOpen={this.state.isWebClientConfigDropdownOpen}>
                              <div className={style.dropdownWrapper}>
                                <section className={style.sectionWrapper}>
                                  <SectionHeading heading={'Operational Settings'} description={'Enable the bot to collect user information and initiate conversations'} />
                                  <FormGroup
                                    style={{ display: 'flex', flexDirection: 'row-reverse', justifyContent: 'flex-end', marginBottom: 0, padding: '0px 20px 0px 0px' }}
                                    label={lang.tr('admin.workspace.bots.create.self_triggered_bot')}
                                    labelInfo={<><InfoTip icon={<InfoIcon />} info={lang.tr('admin.workspace.bots.create.self_triggered_bot_info')} /></>}
                                  >
                                    <Checkbox
                                      name="selfTriggeredBot"
                                      checked={this.state.selfTriggeredBot}
                                      onChange={this.handleInputSelfTriggeredBot}
                                    />
                                  </FormGroup>
                                  <FormGroup
                                    style={{ display: 'flex', flexDirection: 'row-reverse', justifyContent: 'flex-end', alignItems: 'center', marginBottom: 0, borderRadius: '10px 10px 0 0 ' }}
                                    label={lang.tr('admin.workspace.bots.create.startup_form')}
                                    labelInfo={<><InfoTip icon={<InfoIcon />} info={lang.tr('admin.workspace.bots.create.startup_form_info')} /></>}
                                  >
                                    <Checkbox
                                      name="name"
                                      checked={this.state.startupForm.name}
                                      onChange={this.handleInputChangedUserData}
                                    />
                                  </FormGroup>
                                  <FormGroup
                                    style={{ width: '50%', marginBottom: '10px', border: '1px solid #efefef', padding: '8px', borderRadius: '10px' }}
                                  >
                                    <>
                                      <InputGroup
                                        id="title"
                                        name="title"
                                        placeholder="Title of user information form"
                                        value={this.state.startupForm.title}
                                        maxLength={100}
                                        onChange={this.handleInputChangedUserDataTitle}
                                        disabled={!this.state.startupForm.name}
                                      />
                                      <Checkbox
                                        style={{ display: 'inline-block', fontSize: '14px', marginRight: '20px' }}
                                        label={'Name'}
                                        name="name"
                                        checked={true}
                                        disabled
                                      />
                                      <Checkbox
                                        style={{ display: 'inline-block', fontSize: '14px', marginRight: '20px' }}
                                        label={'Phone Number'}
                                        name="phoneNumber"
                                        checked={this.state.startupForm.phoneNumber}
                                        onChange={this.handleInputChangedUserData}
                                        disabled={!this.state.startupForm.name}
                                      />
                                      <Checkbox
                                        style={{ display: 'inline-block', fontSize: '14px', marginRight: '20px' }}
                                        label={'Email'}
                                        name="email"
                                        checked={this.state.startupForm.email}
                                        onChange={this.handleInputChangedUserData}
                                        disabled={!this.state.startupForm.name}
                                      />
                                    </>
                                  </FormGroup>
                                  <FormGroup
                                    style={{ display: 'flex', flexDirection: 'row-reverse', justifyContent: 'flex-end', alignItems: 'center', marginBottom: 0, borderRadius: '10px 10px 0 0 ' }}
                                    label={'Click to call'}
                                    labelInfo={<><InfoTip icon={<InfoIcon />} info={lang.tr('admin.workspace.bots.create.clickToCall_info')} /></>}
                                  >
                                    <Checkbox
                                      name="clickToCallEnable"
                                      checked={this.state.clickToCallEnabled}
                                      onChange={this.handleClickToCallChange}
                                    />
                                  </FormGroup>
                                  <FormGroup labelFor="clickToCall">
                                    <Select
                                      styles={{
                                        container: (baseStyles, state) => ({
                                          ...baseStyles,
                                          width: '50%'
                                        })
                                      }}
                                      classNamePrefix="select-input"
                                      className={`${style.selectInput}`}
                                      id="configSelect"
                                      name="clickToCall"
                                      options={this.state.clickToCallOptions}
                                      value={this.state.clickToCall}
                                      onChange={this.handleClickToCallOptionChange}
                                      isDisabled={!this.state.clickToCallEnabled}
                                    />
                                  </FormGroup>
                                </section>
                                <section className={style.sectionWrapper}>
                                  <SectionHeading heading={'Widget Customization'} description={'Set a welcome message, upload a profile image, and select a web widget theme color.'} />
                                  <div>
                                    <FormGroup label={lang.tr('admin.workspace.bots.create.startup_message')} labelFor="startup_message"
                                      style={{ paddingTop: '5px', width: '50%' }}
                                    >
                                      <InputGroup
                                        id="startup_message"
                                        name="startup_message"
                                        value={this.state.startup_message}
                                        maxLength={30}
                                        onChange={this.handleInputChanged}
                                      />
                                    </FormGroup>
                                  </div>
                                  <FormGroup label={lang.tr('admin.workspace.bots.create.composerPlaceholder')} labelFor="composerPlaceholder"
                                    style={{ paddingTop: '5px', width: '50%' }}
                                  >
                                    <InputGroup
                                      id="composerPlaceholder"
                                      name="composerPlaceholder"
                                      value={this.state.composerPlaceholder}
                                      maxLength={30}
                                      onChange={this.handleInputChanged}
                                    />
                                  </FormGroup>
                                  {/* <div
                                    className={style.botAvatar}
                                    style={{ overflow: 'hidden', display: 'flex', paddingBottom: '20px' }}
                                  >
                                    <div>
                                      <label>Select a chat icon</label>
                                      <p style={{ marginTop: '5px', color: '#5c7080', fontSize: '12px', paddingBottom: '10px' }}>
                                        This image will be icon for widget bubble. Drag and drop an associated image here.
                                      </p>
                                    </div>
                                      <DropzoneComponent selectedImage={this.state.widgetIconPreview} botAvatar={this.setFileName.bind(this)} handleDeleteFileName={this.deleteFileName.bind(this)}/>
                                  </div> */}
                                  <div style={{ display: 'grid', gridTemplateColumns: '50% 50%', height: '100%' }}>
                                    {/* theme and color picker */}
                                    <div>
                                      <div style={{ padding: '0 20px 20px 0' }}>
                                        <label>Theme</label>
                                        {/* <p style={{ marginTop: '5px', color: '#5c7080', fontSize: '12px', paddingBottom: '10px' }}>
                                          Configure theme and color for the widget components and see on the right how it will look on the production.
                                        </p> */}
                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                          {/* Maximized widget theme */}
                                          <div style={{ width: '48%' }}>
                                            <p style={{ fontFamily: 'Barlow Medium', marginBottom: '4px', color: '#333333' }}>Maximized widget</p>
                                            <div className={style.colorPickerContainer}>
                                              <span style={{fontFamily: 'Barlow Medium'}}>{this.state.chatTheme?.theme?.toUpperCase()}</span>
                                              <input type="color" name="max-widget-theme" className={style.colorPicker} value={this.state.chatTheme?.theme} onChange={(e) => {
                                                setChatTheme({ ...this.state.chatTheme, theme: e.target.value })
                                              }} />
                                            </div>
                                          </div>
                                          {/* Minimized widget theme */}
                                          <div style={{ width: '48%' }}>
                                            <p style={{ fontFamily: 'Barlow Medium', marginBottom: '4px', color: '#333333' }}>Minimized widget</p>
                                            <div className={style.colorPickerContainer}>
                                              <span style={{fontFamily: 'Barlow Medium'}}>{this.state.chatTheme?.widget?.bubble?.toUpperCase()}</span>
                                              <input type="color" name="min-widget-theme" className={style.colorPicker} value={this.state.chatTheme?.widget?.bubble} onChange={(e) => {
                                                setChatTheme({ ...this.state.chatTheme, widget: { ...this.state.chatTheme?.widget, bubble: e.target.value } })
                                              }} />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div style={{ padding: '0 20px 20px 0' }}>
                                        <label>Colors</label>
                                        {/* <p style={{ marginTop: '5px', color: '#5c7080', fontSize: '12px', paddingBottom: '10px' }}>
                                          Configure theme and color for the widget components and see on the right how it will look on the production.
                                        </p> */}
                                        {/* user message colors */}
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                                          <div style={{ width: '48%' }}>
                                            <p style={{ fontFamily: 'Barlow Medium', marginBottom: '4px', color: '#333333' }}>User bubble</p>
                                            <div className={style.colorPickerContainer}>
                                              <span style={{fontFamily: 'Barlow Medium'}}>{this.state.chatTheme?.user?.bubble?.toUpperCase()}</span>
                                              <input type="color" name="user-bubble" className={style.colorPicker} value={this.state.chatTheme?.user?.bubble} onChange={(e) => {
                                                setChatTheme({ ...this.state.chatTheme, user: { ...this.state.chatTheme?.user, bubble: e.target.value } })
                                              }} />
                                            </div>
                                          </div>
                                          <div style={{ width: '48%' }}>
                                            <p style={{ fontFamily: 'Barlow Medium', marginBottom: '4px', color: '#333333' }}>User text</p>
                                            <div className={style.colorPickerContainer}>
                                              <span style={{fontFamily: 'Barlow Medium'}}>{this.state.chatTheme?.user?.text?.toUpperCase()}</span>
                                              <input type="color" name="user-text" className={style.colorPicker} value={this.state.chatTheme?.user?.text} onChange={(e) => {
                                                setChatTheme({ ...this.state.chatTheme, user: { ...this.state.chatTheme?.user, text: e.target.value } })
                                              }} />
                                            </div>
                                          </div>
                                        </div>
                                        {/* bot message colors */}
                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                          <div style={{ width: '48%' }}>
                                            <p style={{ fontFamily: 'Barlow Medium', marginBottom: '4px', color: '#333333' }}>Bot bubble</p>
                                            <div className={style.colorPickerContainer}>
                                              <span style={{fontFamily: 'Barlow Medium'}}>{this.state.chatTheme?.bot?.bubble?.toUpperCase()}</span>
                                              <input type="color" name="bot-bubble" className={style.colorPicker} value={this.state.chatTheme?.bot?.bubble} onChange={(e) => {
                                                setChatTheme({ ...this.state.chatTheme, bot: { ...this.state.chatTheme?.bot, bubble: e.target.value } })
                                              }} />
                                            </div>
                                          </div>
                                          <div style={{ width: '48%' }}>
                                            <p style={{ fontFamily: 'Barlow Medium', marginBottom: '4px', color: '#333333' }}>Bot text</p>
                                            <div className={style.colorPickerContainer}>
                                              <span style={{fontFamily: 'Barlow Medium'}}>{this.state.chatTheme?.bot?.text?.toUpperCase()}</span>
                                              <input type="color" name="bot-text" className={style.colorPicker} value={this.state.chatTheme?.bot?.text} onChange={(e) => {
                                                setChatTheme({ ...this.state.chatTheme, bot: { ...this.state.chatTheme?.bot, text: e.target.value } })
                                              }} />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div style={{ padding: '0 20px 20px 0' }}>
                                        <label>Border Radius</label>
                                        <Slider
                                          className={style.slider}
                                          min={4}
                                          max={16}
                                          stepSize={1}
                                          labelStepSize={16}
                                          onChange={ (value) => setChatTheme({ ...this.state.chatTheme, widget: { ...this.state.chatTheme?.widget, radius: value } })}
                                          value={Number(this.state.chatTheme?.widget?.radius)}
                                          initialValue={Number(this.state.chatTheme?.widget?.radius)}
                                        />
                                      </div>
                                      <div style={{ padding: '0 20px 20px 0' }}>
                                        <label>Variant</label>
                                        <RadioGroup onChange={(e) => {
                                          setChatTheme({ ...this.state.chatTheme, widget: { ...this.state.chatTheme?.widget, variant: e.currentTarget.value } })
                                        }} selectedValue={this.state.chatTheme?.widget?.variant} inline>
                                          <Radio label={'Solid'} value={'solid'} />
                                          <Radio label={'Soft'} value={'soft'} />
                                        </RadioGroup>
                                      </div>
                                      <div style={{ padding: '0 20px 20px 0' }}>
                                        <label>Widget position</label>
                                        <RadioGroup onChange={(e) => {
                                          setChatTheme({ ...this.state.chatTheme, widget: { ...this.state.chatTheme?.widget, position: e.currentTarget.value } })
                                        }} selectedValue={this.state.chatTheme?.widget?.position} inline>
                                          <Radio label={'Left'} value={'left'} />
                                          <Radio label={'Right'} value={'right'} />
                                        </RadioGroup>
                                      </div>
                                    </div>
                                    <div style={{ position: 'relative', borderRadius: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', background: '#d9d9d9' }}>
                                      <div style={{ position: 'absolute', width: `${this.state.isChatOpen ? 'auto' : '100%'}`, bottom: '30px', [`${this.state.chatTheme?.widget?.position}`]: '30px' }}>
                                        {
                                          !this.state.isChatOpen ?
                                            <>
                                              {this.state.startup_message ?
                                                <div className='startup_message_container' style={{ marginBottom: '10px', display: 'flex', flexDirection: 'column', alignItems: `${this.state.chatTheme?.widget?.position === 'right' ? 'flex-end' : 'flex-start'}`, gap: '6px', cursor: 'pointer', position: 'absolute', bottom: '60px', [`${this.state.chatTheme?.widget?.position}`]: '4px', width: 'fit-content' }}>
                                                  <div style={{ width: '15px', height: '15px', padding: '2px', alignItems: 'center', display: 'flex', justifyContent: 'center', background: 'rgba(0, 0, 0, 0.4)', borderRadius: '50%', marginRight: '4px' }}
                                                  >
                                                    <SmallCloseBtn />
                                                  </div>
                                                  <div style={{ textAlign: 'left', padding: '10px', boxShadow: '0px 2px 14px #3d3d3d0d', border: '1px solid #eee', borderRadius: '10px', background: '#fff' }}>
                                                    {this.state.startup_message}
                                                  </div>
                                                </div>
                                                :
                                                <></>
                                              }

                                              <button
                                                className={'bpw-widget-btn bpw-floating-button'}
                                                style={{ backgroundColor: `${this.state.chatTheme?.widget.bubble}`, position: 'absolute', bottom: '4px', [`${this.state.chatTheme?.widget?.position}`]: '4px' }}
                                                onClick={toggleChat}
                                              >
                                                <BotChatIcon src={this.state.widgetIconUrl} />
                                              </button> </> : <BotChatTemplate parentProps={this} toggleChat={toggleChat} />
                                        }
                                      </div>
                                    </div>
                                  </div>
                                </section>
                              </div>
                            </Collapse>
                          </div>
                        }
                        {
                          this.state.isFacebookEnabled ?
                            <div style={{ paddingBottom: '20px' }}>
                              <Button style={this.state.isMessengerDropdownOpen ? { borderRadius: '6px 6px 0 0', background: 'rgba(29, 108, 144, 0.2)', border: '1px solid var(--theme-color)' } : { borderRadius: '6px', background: '#fff', border: '1px solid rgb(151, 151, 151)' }} className={style.collapsible} onClick={this.handleMessengerDropdownClick.bind(this)} rightIcon={this.state.isMessengerDropdownOpen ? 'chevron-up' : 'chevron-down'}>
                                <FacebookIcon /> Messenger
                              </Button>
                              <Collapse isOpen={this.state.isMessengerDropdownOpen}>
                                <div className={style.dropdownWrapper}>
                                  <MessengerConfigDialog parent={this} />
                                </div>
                              </Collapse>
                            </div> : <></>
                        }
                        {
                          this.state.isInstagramEnabled ?
                            <div style={{ paddingBottom: '20px' }}>
                              <Button style={this.state.isInstagramDropdownOpen ? { borderRadius: '6px 6px 0 0', background: 'rgba(29, 108, 144, 0.2)', border: '1px solid var(--theme-color)' } : { borderRadius: '6px', background: '#fff', border: '1px solid rgb(151, 151, 151)' }} className={style.collapsible} onClick={this.handleInstagramDropdownClick.bind(this)} rightIcon={this.state.isInstagramDropdownOpen ? 'chevron-up' : 'chevron-down'}>
                                <InstagramIcon /> Instagram
                              </Button>
                              <Collapse isOpen={this.state.isInstagramDropdownOpen}>
                                <div className={style.dropdownWrapper}>
                                  <InstagramConfigDialog parent={this} />
                                </div>
                              </Collapse>
                            </div> : <></>
                        }
                        {
                          this.state.isTelegramEnabled ?
                            <div style={{ paddingBottom: '20px' }}>
                              <Button style={this.state.isTelegramDropdownOpen ? { borderRadius: '6px 6px 0 0', background: 'rgba(29, 108, 144, 0.2)', border: '1px solid var(--theme-color)' } : { borderRadius: '6px', background: '#fff', border: '1px solid rgb(151, 151, 151)' }} className={style.collapsible} onClick={this.handleTelegramDropdownClick.bind(this)} rightIcon={this.state.isTelegramDropdownOpen ? 'chevron-up' : 'chevron-down'}>
                                <TelegramIcon /> Telegram
                              </Button>
                              <Collapse isOpen={this.state.isTelegramDropdownOpen}>
                                <div className={style.dropdownWrapper}>
                                  <TelegramConfigDialog parent={this} />
                                </div>
                              </Collapse>
                            </div> : <></>
                        }
                        {
                          this.getRequiredServices().length ?
                            <div style={{ paddingBottom: '20px' }}>
                              <Button style={this.state.isProjectsDropdownOpen ? { borderRadius: '6px 6px 0 0', background: 'rgba(29, 108, 144, 0.2)', border: '1px solid var(--theme-color)' } : { borderRadius: '6px', background: '#fff', border: '1px solid rgb(151, 151, 151)' }} className={style.collapsible} onClick={this.handleProjectsDropdownClick.bind(this)} rightIcon={this.state.isProjectsDropdownOpen ? 'chevron-up' : 'chevron-down'}>
                                {this.getEnableXServices()}
                              </Button>
                              <Collapse isOpen={this.state.isProjectsDropdownOpen}>
                                <div className={style.dropdownWrapper}>
                                  <div className={style.stepSubTitle}>
                                    Link your bot with the EnableX project linked to the workspace.{' '}
                                  </div>
                                  <label htmlFor="">Select EnableX Project<span style={{color: '#EF1706'}}>*</span></label>
                                  <Select
                                    styles={{
                                      container: (baseStyles, state) => ({
                                          ...baseStyles,
                                          width: '50%',
                                      })
                                    }}
                                    classNamePrefix="select-input"
                                    className={style.selectInput}
                                    id="select-bot-projects"
                                    tabIndex="3"
                                    menuPosition="fixed"
                                    options={this.state.availableProjects}
                                    value={this.state.selectedProject}
                                    placeholder={'Select Project'}
                                    onChange={project => {
                                      this.setState({
                                        selectedProject: {
                                          app_id: project.app_id,
                                          app_key: project.app_key,
                                          low_code_url: project.low_code_url,
                                          wa_phone_number: project.WhatsApp?.phone_number || '',
                                          wa_business_name: project.WhatsApp?.business_name || '',
                                          rcs_phone_number: project.RCS?.phone_number || '',
                                          voice_phone_number: '',
                                          whatsapp: project.services_incl?.whatsapp || false,
                                          rcs: project.services_incl?.rcs || false,
                                          video: project.services_incl?.video || false,
                                          audio: project.services_incl?.voice || false,
                                          app_name: project.app_name
                                        }
                                      })
                                      if (Object.keys(project.voice).length > 0 && Object.keys(project.voice.phone).length > 0 && this.state.isVoiceBotEnabled) {
                                        const numbers = project.voice.phone
                                        const options = this.createNumberOptions(numbers)
                                        this.setState({ availableVoiceBotNumbers: options })
                                      }
                                    }}
                                    getOptionLabel={o => {
                                      const enabled_services: string[] = []
                                      if (o.services_incl?.whatsapp) {
                                        enabled_services.push('Whatsapp')
                                      }
                                      if (o.services_incl?.rcs) {
                                        enabled_services.push('RCS')
                                      }
                                      if (o.services_incl?.video) {
                                        enabled_services.push('Video Call')
                                      }
                                      if (o.services_incl?.voice) {
                                        enabled_services.push('Phone Call or Voice Bot')
                                      }
                                      const serviceString = enabled_services.length > 0 ? ` - (${enabled_services.join(', ')})` : ''
                                      return `${o.app_name}${serviceString}`
                                    }}
                                    getOptionValue={o => o.app_id}
                                  />
                                  {
                                    this.state.isVoiceBotEnabled && this.state.selectedProject?.app_id ?
                                      <div className={style.voiceBotConfigContainer} style={{ paddingTop: '16px' }}>
                                        <FormGroup label={'Voice bot Interaction language'} labelFor="voiceBotLanguage" labelInfo={<InfoTip icon={<InfoIcon />} info={lang.tr('config.voiceBotLanguage_info')} />}>
                                          <Select
                                            styles={{
                                              container: (baseStyles, state) => ({
                                                ...baseStyles,
                                                width: '50%'
                                              })
                                            }}
                                            className={style.selectInput}
                                            id="configSelect"
                                            name="voiceBotLanguage"
                                            options={this.state.voiceBotLanguages}
                                            value={this.state.voiceBotLanguage}
                                            onChange={this.handleVoiceBotLanguageChange}
                                          />
                                        </FormGroup>
                                        <label htmlFor="">Select Phone Number for Voice Bot</label>
                                        <Select
                                          styles={{
                                            container: (baseStyles, state) => ({
                                              ...baseStyles,
                                              width: '50%'
                                            })
                                          }}
                                          className={style.selectInput}
                                          id="select-voice-bot-number"
                                          tabIndex="3"
                                          menuPosition="fixed"
                                          options={this.state.availableVoiceBotNumbers}
                                          value={this.state.selectedPhoneNumber}
                                          placeholder={'Select Voice Bot Number'}
                                          onChange={option => {
                                            this.setState({
                                              selectedProject: {
                                                ...this.state.selectedProject,
                                                voice_phone_number: option.label
                                              },
                                              selectedPhoneNumber: option,
                                              voice_bot_phone_number: option.label,
                                              voice_bot_phone_id: option.value,
                                            })
                                          }}
                                        />
                                      </div> : <></>
                                  }
                                  <p style={{ marginTop: '5px', color: '#333', fontSize: '14px', paddingBottom: '10px', fontFamily: 'Barlow Medium' }}>
                                    Chatbot uses EnableX API for the provision of WhatsApp, Voice, and Video channels.
                                  </p>
                                </div>
                              </Collapse>
                            </div> : <></>
                        }
                      </div>
                    </div>
                    <div className={''} style={{ margin: '2rem 0 0 0' }}>
                      {!!this.state.error && <Callout intent={Intent.DANGER}>{this.state.error}</Callout>}
                      <div className={style.buttonGroup}>
                        <Button
                          type="button"
                          text={this.state.isProcessing ? lang.tr('pleaseWait') : lang.tr('admin.prev')}
                          onClick={this.goToCreateFormPage.bind(this)}
                          intent={Intent.NONE}
                          large={true}
                        />
                        {this.state.isProcessing ? null : (
                          <Button
                            type="button"
                            text={lang.tr('admin.next')}
                            onClick={this.gotToSelectTemplatePage.bind(this)}
                            intent={Intent.PRIMARY}
                            large={true}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {/* Select Template */}
                {this.state.goToTemplatesPage && (
                  <div className={style.newBotContainer}>
                    <div className={style.stepTitle}>Select Your Bot's Template</div>
                    <div className={style.stepSubTitle} style={{paddingBottom: '32px'}}>
                      Select a predefined call flow template to customize or select one to start from scratch.
                    </div>

                    <div className={style.templateList} style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
                      {this.state.templates.map((template: any) => {
                        return (
                          <div className={cx('template-item', style.templateItems)}>
                            {template.options.map(item => {
                              return (
                                <div
                                  className={cx(
                                    style.templateItem,
                                    this.state.selectedTemplate === item ? 'selected' : ''
                                  )}
                                >
                                  <label htmlFor={item.id} onClick={() => this.handleTemplateSelection(item)}>
                                    <div>
                                      <div className={style.templateName}>{item.name}</div>
                                      <div className={style.templateDesc}>
                                        <ul>
                                          {item.details.list.map((listItem, index) => (
                                            <li key={index}>{listItem}</li>
                                          ))}
                                        </ul>
                                      </div>
                                      <input
                                        type="radio"
                                        name="bot_template"
                                        id={item.id}
                                        style={{ visibility: 'hidden' }}
                                      />
                                    </div>
                                    {item.details.previewUrl && (
                                      <PreviewDialog
                                        title={item.name}
                                        desc={item.desc}
                                        content={`admin/images/${item.details.previewUrl}`}
                                      />
                                    )}
                                  </label>
                                </div>
                              )
                            })}
                          </div>
                        )
                      })}
                    </div>

                    <div style={{ margin: '2rem 0 0 0' }}>
                      {!!this.state.error && <Callout intent={Intent.DANGER}>{this.state.error}</Callout>}
                      <div className={style.buttonGroup}>
                        <Button
                          type="button"
                          text={this.state.isProcessing ? lang.tr('pleaseWait') : lang.tr('admin.prev')}
                          onClick={this.goToCreateFormPage.bind(this)}
                          intent={Intent.NONE}
                          large={true}
                        />
                        {this.state.isProcessing ? null : (
                          <Button
                            type="button"
                            text={'Save'}
                            onClick={this.createBot.bind(this)}
                            intent={Intent.PRIMARY}
                            large={true}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </form>
            </div>
          </div>
        </Fragment>
      </PageContainer>
    )
  }
}

const mapStateToProps = (state: AppState) => state.bots
const connector = connect(mapStateToProps, { fetchBotTemplates, fetchBotCategories, fetchBots })

export default connector(NewBot)
